module.exports = __webpack_public_path__ + "media/audio7.be686c3a.mp3";